<template>
  <div
    class="app-main-content"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <customer-share-tree-grid
      v-show="view==='list'"
      ref="customerShareTreeGrid"
      style="flex: 1"
      :model-type="2"
      :show-source-type="false"
      no="1"
      @look="lookHandle"
    />
    <customer-workspace
      v-show="view==='detail'"
      ref="customerWorkspace"
      :model-type="2"
      :show-source-type="false"
      no="2"
      @back="backToList"
    />
  </div>
</template>

<script>
import customerShareTreeGrid from './components/crm/customerShareTreeGrid'
import customerWorkspace from './components/crm/customerWorkspace'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'

export default {
  name: 'ShareCustomer',
  components: { customerShareTreeGrid, customerWorkspace },
  data() {
    return {
      view: 'list'
    }
  },
  created() {
  },
  mounted() {
    SalesUtil.checkCrmExpire(this.$route, this.$router)
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    // 查看
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    // 详情返回
    backToList(isRefresh) {
      this.view = 'list'
      if (isRefresh) {
        this.$refs.customerShareTreeGrid.toQuery()
      }
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.customerWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.customerShareTreeGrid.rowData
      }
      this.$refs.customerWorkspace.onShow(type, rowData, row)
    }
  }
}
</script>
